import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import ReactPlayer from 'react-player'
import loadable from '@loadable/component'
import Shape from '../svg/shape-header.svg'

import SanityResponsiveImage from './SanityResponsiveImage'

const ReviewDisplay = loadable(() => import('./ReviewDisplay'))
const SchemaHotel = loadable(() => import('./Schema/Hotel'))
const Buttons = loadable(() => import('./Buttons'))
const Content = loadable(() => import('./HeadingContent'))
const BookingSearch = loadable(() => import('./BookingSearch'))

const PageBuilderHeading = ({ block, location, priority = false }) => {
  const {
    title,
    reducedSize,
    headerHeight,
    subtitle,
    hideSubtitle,
    reviews,
    text,
    buttons,
    bgImage,
    showBookingSearch,
    youtubeUrl,
    youtubeUrlMobile,
  } = block

  let mobileHeight
  let desktopHeight

  switch (headerHeight) {
    case 'Tall':
      mobileHeight = 'h-heading-m-tall'
      desktopHeight = 'md:h-heading-d-tall'
      break
    case 'Short':
      mobileHeight = 'h-heading-m-short'
      desktopHeight = 'md:h-heading-d-short'
      break
    default:
      mobileHeight = 'h-heading-m'
      desktopHeight = 'md:h-heading-d'
  }

  if (showBookingSearch === true) {
    mobileHeight = 'min-h-[800px]'
  }

  return (
    <header
      className={`relative w-full ${mobileHeight} ${desktopHeight} flex items-end`}
    >
      <div className="absolute inset-0 w-full h-full overflow-hidden text-gray-100">

        {bgImage && (
          <SanityResponsiveImage
            image={bgImage}
            className="object-cover w-full h-full border-b"
            width={1600}
            height={900}
            widths={[500, 768, 1200, 1600]}
            mobile={{ width: 500, height: 520, widths: [320, 500] }}
            sizes="100vw"
            alt={`${title} - header`}
            priority={priority}
          />
        )}
        <div className="absolute inset-0 w-full h-full bg-black bg-opacity-35" />
        <Shape className="absolute bottom-0 z-10 w-full h-3 md:inset-x-0 min-w-screen-xs md:min-w-screen-lg" />
      </div>
      <div
        className={`container grid grid-cols-12 z-10 pt-8 md:pt-16 ${
          reducedSize ? 'pb-16 md:pb-40' : 'pb-16 md:pb-24'
        }`}
      >
        <div className="col-span-12 xl:col-span-10 xl:col-start-2">
          {reviews === true && (
            <ReviewDisplay textClasses="text-white text-sm" />
          )}
          <Content
            reducedSize={reducedSize}
            title={title}
            subtitle={subtitle}
            hideSubtitle={hideSubtitle}
            text={text}
          />
          
          {buttons?.length > 0 && <Buttons buttons={buttons} />}

          {showBookingSearch === true && 
            <div className="-mx-4 md:mx-0">
              <BookingSearch />
            </div>
          }
        </div>
      </div>
      {location.pathname === '/hotel/' && <SchemaHotel />}
    </header>
  )
}

PageBuilderHeading.defaultProps = {
  block: ``,
  location: {},
}

export default PageBuilderHeading
